import { render, staticRenderFns } from "./InterfaceSettingsLoginScreen.vue?vue&type=template&id=bbcbb57e&scoped=true"
import script from "./InterfaceSettingsLoginScreen.vue?vue&type=script&lang=js"
export * from "./InterfaceSettingsLoginScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcbb57e",
  null
  
)

export default component.exports